// extracted by mini-css-extract-plugin
export default {"scrollableContainer":"horizontal-scroller_scrollableContainer__4aqmv","container":"horizontal-scroller_container__DjgSZ"};